module.exports = __webpack_public_path__ + "media/alarm.d3c683f4.mp3";